export default function validateClienteFormUpdate(fieldName, fieldValue, fields) {
    let validationErrors = {};
    let numberOfErrors = 0;
    if (fieldName !== null || fieldValue !== null) {
        switch (fieldName) {
            case "cli_nombre":
                if (!fieldValue) {
                    validationErrors.cli_nombre = "El nombre del Cliente es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "cli_tipide":
                if (!fieldValue) {
                    validationErrors.cli_tipide = "Escoja el tipo identificación";
                    numberOfErrors += 1;
                }
                break;
            case "cli_numide":
                if (!fieldValue) {
                    validationErrors.cli_numide = "El número de identificación es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            case "ciu_id":
                if (!fieldValue) {
                    validationErrors.ciu_id = "La ciudad es obligatoria";
                    numberOfErrors += 1;
                }
                break;
            case "cli_email":
                if (!fieldValue) {
                    validationErrors.cli_email = "El email del cliente es obligatorio";
                    numberOfErrors += 1;
                }
                break;

           /*  case "cli_telefono":
                if (!fieldValue) {
                    validationErrors.cli_telefono = "El teléfono es obligatorio";
                    numberOfErrors += 1;
                }
                break; */
            case "cli_celular":
                if (!fieldValue) {
                    validationErrors.cli_celular = "El celular es obligatorio";
                    numberOfErrors += 1;
                }
                break;
            /* case "cli_direccion":
                if (!fieldValue) {
                    validationErrors.cli_direccion = "La dirección del cliente es obligatoria";
                    numberOfErrors += 1;
                }
                break; */
            case "cli_estado":
                if (!fieldValue) {
                    validationErrors.cli_estado = "El estado del cliente es obligatorio";
                    numberOfErrors += 1;
                }
                break;

            default:
                break;
        }
    } else {
        if (!fields.cli_nombre) {
            validationErrors.cli_nombre = "El nombre del Cliente es obligatorio";
            numberOfErrors += 1;
        }
        if (!fields.cli_tipide) {
            validationErrors.cli_tipide = "Escoja el tipo identificación";
            numberOfErrors += 1;
        }
        if (!fields.cli_numide) {
            validationErrors.cli_numide = "El número de identificación es obligatorio";
            numberOfErrors += 1;
        }

        if (!fields.ciu_id) {
            validationErrors.ciu_id = "La ciudad es obligatoria";
            numberOfErrors += 1;
        }
        if (!fields.cli_email) {
            validationErrors.cli_email = "El email del cliente es obligatorio";
            numberOfErrors += 1;
        }
        /* if (!fields.cli_telefono) {
            validationErrors.cli_telefono = "El teléfono es obligatorio";
            numberOfErrors += 1;
        } */

        if (!fields.cli_celular) {
            validationErrors.cli_celular = "El celular es obligatorio";
            numberOfErrors += 1;
        }
        /* if (!fields.cli_direccion) {
            validationErrors.cli_direccion = "La dirección del cliente es obligatoria";
            numberOfErrors += 1;
        } */

        if (!fields.cli_estado) {
            validationErrors.cli_estado = "El estado del cliente es obligatorio";
            numberOfErrors += 1;
        }

    }

    return { validationErrors, numberOfErrors }
}